<!-- JDJL-order-pay -->

<template>
  <div>去支付 ...</div>
</template>

<script>
import { cookie_get } from "@/util/util";
import { ORDER_TYPE_JDJL } from "@/api/constant";
import { Toast, Dialog } from "vant";

export default {
  created() {
    var jd_h5_from_origin = cookie_get("jd_h5_from_origin");
    if (jd_h5_from_origin && jd_h5_from_origin != location.origin) {
      location.href = jd_h5_from_origin + location.pathname + location.search;
      return;
    }
  },

  mounted() {
    this.go_select_card_pay(); // 这里未处理 xizang 支付 逻辑
  },

  methods: {
    go_select_card_pay() {
      if (!this.$route.query.JDJL_orderId) {
        Dialog.alert({ message: "#19 no query.JDJL_orderId" });
        return;
      }

      Toast("去支付 ...");

      var _this = this;

      this.$router.push({
        path: "/select-card-pay",
        query: {
          cateId: _this.$route.query.cateId,
          goodsType: ORDER_TYPE_JDJL,
          JDJL_orderId: _this.$route.query.JDJL_orderId,
        },
      });
    },
  },
};
</script>
